import { render, staticRenderFns } from "./PromotionsRetailerPage.vue?vue&type=template&id=46791877&scoped=true"
import script from "./PromotionsRetailerPage.vue?vue&type=script&lang=js"
export * from "./PromotionsRetailerPage.vue?vue&type=script&lang=js"
import style0 from "./PromotionsRetailerPage.vue?vue&type=style&index=0&id=46791877&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46791877",
  null
  
)

export default component.exports